export enum FileDocumentTypeCode {
    PDF = 'application/pdf',
    EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
}